import React, { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { LeaveHistory } from "@/components/leave/LeaveHistory";

const TUR = { yillik: "Yıllık İzin", ucretli_izin: "Ücretli İzin", ucretsiz_izin: "Ücretsiz İzin", rapor: "Rapor" };

export function DeletedLeaves({ personnelId, refreshKey }) {
  const [rows, setRows] = useState([]);
  const [openId, setOpenId] = useState(null);
  useEffect(() => {
    api.get(`/annual-leave/deleted?personnel_id=${personnelId}`).then((r) => setRows(r.data.rows || [])).catch(() => setRows([]));
  }, [personnelId, refreshKey]);
  if (!rows.length) return null;
  return (
    <details className="mt-2" data-testid={`deleted-leaves-${personnelId}`}>
      <summary className="cursor-pointer text-[10px] font-bold uppercase tracking-wider text-rose-600 select-none">Silinen Kayıtlar ({rows.length})</summary>
      <ul className="space-y-1 mt-1">
        {rows.map((lv) => (
          <li key={lv.id} className="bg-rose-50/50 border border-rose-200 rounded-md px-3 py-1.5 text-xs" data-testid={`deleted-leave-${lv.id}`}>
            <div className="flex items-center gap-3 flex-wrap">
              <span className="font-semibold line-through text-slate-500">{fmtDate(lv.baslangic)} → {fmtDate(lv.bitis)}</span>
              <span className="text-slate-600">{TUR[lv.tur] || lv.tur} · {lv.gun_sayisi} gün</span>
              <span className="text-rose-700">Silen: {lv.deleted_by || "—"} · {new Date(lv.deleted_at).toLocaleString("tr-TR")}</span>
              <button type="button" onClick={() => setOpenId(openId === lv.id ? null : lv.id)} data-testid={`deleted-leave-history-${lv.id}`}
                className="ml-auto inline-flex items-center gap-1 text-[11px] text-slate-600 hover:text-slate-900"><History size={11} /> Geçmiş</button>
            </div>
            {openId === lv.id && <div className="mt-2"><LeaveHistory leaveId={lv.id} /></div>}
          </li>
        ))}
      </ul>
    </details>
  );
}
